import {Injectable} from '@angular/core';

import {Actions, ofType, createEffect} from '@ngrx/effects';
import {of} from 'rxjs';
import {map, switchMap, catchError} from 'rxjs/operators';

import * as ClientsActions from '@app/shared/store/actions/users.actions';

import {ClientsService} from '@app/shared/services/users.service';

@Injectable()
export class ClientsEffects {
  getClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClientsActions.GetClients>(
        ClientsActions.ClientsActionTypes.GET_CLIENT
      ),
      switchMap((action) => {
        return this._ClientsService.getClients(action.payload).pipe(
          map((resp) => {
            return new ClientsActions.GetClientsSuccess(resp);
          }),
          catchError((error) => {
            return of(new ClientsActions.GetClientsError(error));
          })
        );
      })
    )
  );

  getClientsByPhone$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClientsActions.GetClientsByPhone>(
        ClientsActions.ClientsActionTypes.GET_CLIENT_BY_PHONE
      ),
      switchMap((action) => {
        return this._ClientsService.getClientsByPhone(action.payload).pipe(
          map((resp) => {
            return new ClientsActions.GetClientsByPhoneSuccess(resp);
          }),
          catchError((error) => {
            return of(new ClientsActions.GetClientsByPhoneError(error));
          })
        );
      })
    )
  );

  getAllClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClientsActions.GetClients>(
        ClientsActions.ClientsActionTypes.GET_ALL_CLIENTS
      ),
      switchMap((action) => {
        return this._ClientsService.getAllClients().pipe(
          map((resp) => {
            return new ClientsActions.GetAllClientsSuccess(resp);
          }),
          catchError((error) => {
            return of(new ClientsActions.GetAllClientsError(error));
          })
        );
      })
    )
  );

  getManagersByFilialId$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClientsActions.GetManagersByFilial>(
        ClientsActions.ClientsActionTypes.GET_MANAGER_BY_FILIAL
      ),
      switchMap((action) => {
        return this._ClientsService.getManagersByFilialId(action.payload).pipe(
          map((resp) => {
            return new ClientsActions.GetManagersByFilialSuccess(resp);
          }),
          catchError((error) => {
            return of(new ClientsActions.GetManagersByFilialError(error));
          })
        );
      })
    )
  );

  getSortedManagersByFilialId$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClientsActions.GetSortedManagersByFilial>(
        ClientsActions.ClientsActionTypes.GET_SORTED_MANAGER_BY_FILIAL
      ),
      switchMap((action) => {
        return this._ClientsService.getSortedManagersByFilialId(action.payload).pipe(
          map((resp) => {
            return new ClientsActions.GetSortedManagersByFilialSuccess(resp);
          }),
          catchError((error) => {
            return of(new ClientsActions.GetSortedManagersByFilialError(error));
          })
        );
      })
    )
  );

  getManagersByHeadManager$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClientsActions.GetManagersByHeadManager>(
        ClientsActions.ClientsActionTypes.GET_MANAGER_BY_HEAD_MANAGER
      ),
      switchMap((action) => {
        return this._ClientsService.getManagerByHeadManger().pipe(
          map((resp) => {
            return new ClientsActions.GetManagersByHeadManagerSuccess(resp);
          }),
          catchError((error) => {
            return of(new ClientsActions.GetManagersByHeadManagerError(error));
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _ClientsService: ClientsService
  ) {
  }
}
